<footer>
  <section class="container">
    <div class="footer-box">
      <span class="footer-box__title">A Broadfactor</span>
      <a class="footer-box__link" routerLink="broadfactor/sobre">Sobre nós</a>
      <a
        class="footer-box__link"
        target="_blank"
        href="https://blogbroadfactor.com"
        >Blog</a
      >
    </div>

    <div class="footer-box">
      <span class="footer-box__title">Ajuda</span>
      <a class="footer-box__link" routerLink="contatos">Central de Ajuda</a>

      <a
        class="footer-box__link"
        target="_blank"
        href="https://broadfactors3-public.s3.sa-east-1.amazonaws.com/Termos/cedente/Termos_+de_Uso_Broadfactor.pdf"
        >Termos de uso</a
      >
      <a
        class="footer-box__link"
        target="_blank"
        href="https://broadfactors3-public.s3.sa-east-1.amazonaws.com/Termos/cedente/Pol%C3%ADtica+de+Privacidade+Broadfactor.pdf"
        >Política de Privacidade (LGPD)</a
      >
    </div>
    <div class="footer-box">
      <div class="footer-box">
        <span class="footer-box__title">Canais de atendimento</span>
        <span class="footer-box__content">contato&#64;broadfactor.com</span>
        <span class="footer-box__content">(47) 99215-7013</span>
      </div>
    </div>
    <div class="footer-box">
      <div class="footer-box__media">
        <span class="footer-box__title">Nossas redes</span>
        <a target="_blank" href="https://www.instagram.com/broadfactoroficial/">
          <img
            class="social_media"
            src="../../../assets/img/footer/Vector-1.png"
            alt="Instagram"
        /></a>
        <a target="_blank" href="https://www.facebook.com/broadfactoroficial/">
          <img
            class="social_media"
            src="../../../assets/img/footer/Vector.png"
            alt="Facebook"
        /></a>
        <a target="_blank" href="https://www.linkedin.com/company/broadfactor/">
          <img
            class="social_media"
            src="../../../assets/img/footer/Vector-2.png"
            alt="Linkedin"
        /></a>
        <a
          target="_blank"
          href="https://www.youtube.com/channel/UChxZcuH2MjPLA7ebO4VKqUA"
        >
          <img
            class="social_media"
            src="../../../assets/img/footer/Vector-3.png"
            alt="Youtube"
        /></a>
      </div>
      <img
        class="selo"
        width="100"
        height="100"
        src="https://broadfactors3-public.s3.sa-east-1.amazonaws.com/Termos/seloNivelIinv.png"
        alt="selo Nivel Iinv"
        data-src="https://broadfactors3-public.s3.sa-east-1.amazonaws.com/Termos/seloNivelIinv.png"
      />
    </div>
  </section>
  <p class="footer-author">
    Copyright 2024 Broadfactor Sistema e Apoio Administrativo CNPJ:
    13.995.981/0001-04 | Todos os direitos reservados
  </p>
</footer>
